(() => {
  const STORAGE_KEY = 'roeschBrandContext';
  const VALID_BRANDS = ['roesch', 'feraud'];

  const isValidBrand = (brand) => {
    return VALID_BRANDS.includes(brand);
  };

  const getStoredBrand = () => {
    try {
      const storedBrand = window.localStorage.getItem(STORAGE_KEY);

      return isValidBrand(storedBrand) ? storedBrand : null;
    } catch (error) {
      console.warn(
        'Der Markenkontext konnte nicht gelesen werden.',
        error
      );

      return null;
    }
  };

  const storeBrand = (brand) => {
    if (!isValidBrand(brand)) {
      return;
    }

    try {
      window.localStorage.setItem(STORAGE_KEY, brand);
    } catch (error) {
      console.warn(
        'Der Markenkontext konnte nicht gespeichert werden.',
        error
      );
    }
  };

  const applyColorScheme = (header, brand) => {
    const roeschColorClass = header.dataset.roeschColorClass;
    const feraudColorClass = header.dataset.feraudColorClass;

    if (roeschColorClass) {
      header.classList.remove(roeschColorClass);
    }

    if (feraudColorClass) {
      header.classList.remove(feraudColorClass);
    }

    const activeColorClass =
      brand === 'feraud'
        ? feraudColorClass
        : roeschColorClass;

    if (activeColorClass) {
      header.classList.add(activeColorClass);
    }
  };

  const applySwitcherState = (header, brand) => {
    const brandLinks = header.querySelectorAll(
      '[data-brand-context]'
    );

    brandLinks.forEach((brandLink) => {
      const linkBrand = brandLink.dataset.brandContext;
      const isActive = linkBrand === brand;

      brandLink.classList.toggle('is-active', isActive);

      if (isActive) {
        brandLink.setAttribute('aria-current', 'page');
      } else {
        brandLink.removeAttribute('aria-current');
      }
    });
  };

  const applyDrawerLogos = (brand) => {
    const drawerLogos = document.querySelectorAll(
      '[data-brand-drawer-logo]'
    );

    drawerLogos.forEach((drawerLogo) => {
      const logoBrand =
        drawerLogo.dataset.brandDrawerLogo;

      drawerLogo.hidden = logoBrand !== brand;
    });
  };

  const applyHeaderContext = (header, brand) => {
    if (!header || !isValidBrand(brand)) {
      return;
    }

    header.dataset.currentBrand = brand;

    applyColorScheme(header, brand);
    applySwitcherState(header, brand);
  };

  const applyMenuLinks = (brand) => {
    const menuLinks = document.querySelectorAll(
      '[data-brand-link]'
    );

    menuLinks.forEach((menuLink) => {
      const nextUrl =
        brand === 'feraud'
          ? menuLink.dataset.feraudUrl
          : menuLink.dataset.roeschUrl;

      if (!nextUrl) {
        return;
      }

      if (menuLink.hasAttribute('href')) {
        menuLink.setAttribute('href', nextUrl);
      }

      if (menuLink.hasAttribute('data-link')) {
        menuLink.setAttribute('data-link', nextUrl);
      }
    });
  };

  const applyBrandMenus = (brand) => {
    document.querySelectorAll('[data-brand-menu]').forEach((menu) => {
      menu.hidden = menu.dataset.brandMenu !== brand;
    });
  };

  const applyBrandContextToPage = (brand) => {
    if (!isValidBrand(brand)) {
      return;
    }

    document
      .querySelectorAll('[data-brand-header]')
      .forEach((header) => {
        applyHeaderContext(header, brand);
      });

    applyDrawerLogos(brand);
    applyBrandMenus(brand);
    applyMenuLinks(brand);
  };

  const resolveBrandForPage = () => {
    const header = document.querySelector(
      '[data-brand-header]'
    );

    /*
    * Die beiden Marken-Landingpages überschreiben bewusst
    * den bisher gespeicherten Markenkontext.
    */
    const forcedBrand = header?.dataset.forcedBrand;

    if (isValidBrand(forcedBrand)) {
      storeBrand(forcedBrand);
      return forcedBrand;
    }

    /*
    * Auf allen anderen Seiten bleibt der zuletzt über den
    * Switcher oder eine Landingpage gesetzte Wert erhalten.
    */
    const storedBrand = getStoredBrand();

    if (storedBrand) {
      return storedBrand;
    }

    /*
    * Rückfall für Besucher, bei denen noch kein Wert
    * im Browser gespeichert wurde.
    */
    const serverBrand = header?.dataset.serverBrand;
    const initialBrand = isValidBrand(serverBrand)
      ? serverBrand
      : 'roesch';

    storeBrand(initialBrand);

    return initialBrand;
  };

  const handleBrandSwitcherClick = (event) => {
    const target =
      event.target instanceof Element
        ? event.target
        : null;

    const brandLink = target?.closest(
      '[data-brand-context]'
    );

    if (!brandLink) {
      return;
    }

    const selectedBrand =
      brandLink.dataset.brandContext;

    if (!isValidBrand(selectedBrand)) {
      return;
    }

    storeBrand(selectedBrand);
  };

  const refreshBrandContext = () => {
    const brand = resolveBrandForPage();

    applyBrandContextToPage(brand);
  };

  const initializeBrandContext = () => {
    refreshBrandContext();

    document.addEventListener(
      'click',
      handleBrandSwitcherClick
    );

    document.addEventListener(
      'shopify:section:load',
      refreshBrandContext
    );

    window.addEventListener(
      'pageshow',
      refreshBrandContext
    );
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeBrandContext
    );
  } else {
    initializeBrandContext();
  }
})();